import { Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { LinkOptions } from './types/LinkOptions.js';
import { reusedOptions } from '../../utilities/reusedOptions.js';

/** Defines the "link" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<LinkOptions>({
    name: 'link',
    description: 'Links the package(s) found within the current folder to an existing "cloudpack start" session.',
    options: {
      remote: new Option(
        '--remote [remote]',
        'Link to a remote session. Specify one of the following, listed in order of preference:\n' +
          '- WebSocket URL: e.g., "wss://example.com:9890" or "ws://example.com:9890"\n' +
          '- URL: e.g., "http://example.com" or "https://example.com"\n' +
          '- hostname: e.g., "example.com" (attempts both wss:// and ws:// connections)\n' +
          '- no value: Uses "localhost" (attempts both wss:// and ws:// connections)\n',
      ),
      ignore: new Option(
        '--ignore <packages...>',
        'Ignore these packages when linking. Can be used for packages in the current repo ' +
          'that have issues being bundled.',
      ),
      all: new Option('--all', "Link all internal packages discovered within the linked repo's graph."),
      ignoreResolutions: new Option(
        '--ignore-resolutions [packages...]',
        "Don't apply resolutions from the host repo's package.json to linked packages.",
      ),
      resolveStrategy: new Option(
        '--resolve-strategy <strategy>',
        'Strategy to use when resolving linked packages.\n' +
          '- "dedupe": Attempt to dedupe packages from the resolve map by removing all but the ' +
          'highest version that satisfies semver requirements from all parent entries.\n' +
          `- "duplicate": Allow duplicates in the resolve map (don't bump dependencies).`,
      )
        .choices(['dedupe', 'duplicate'])
        .default('dedupe'),
      cache: reusedOptions.cache(),
      logResolveMap: reusedOptions.logResolveMap(),
    },
    getExecutor: () => import('./execute.js'),
  });
};
